/**
 * ตัวช่วยคัดรอบที่ได้จาก API /admissionnew2022/showrobregister/{param}
 *
 * หนึ่ง param อาจคืนหลายหลักสูตรมาปนกัน (เช่น param 0 และ 5 ใช้ type_std_id
 * เดียวกัน จึงได้ทั้งผู้ช่วยพยาบาลและวิชาชีพครู) การแยกจริงจึงทำด้วย QUOTA_ID
 *
 * quotaIds        เอาเฉพาะ QUOTA_ID เหล่านี้ (ไม่ส่ง = ไม่กรอง)
 * excludeQuotaIds ตัด QUOTA_ID เหล่านี้ออก
 *
 * เรียงจาก ROB_ID น้อยไปมาก เพื่อให้รอบ 1 มาก่อนรอบ 2 (API ส่งมาแบบ DESC)
 */
export function filterQuotaRounds(rounds, options) {
  const { quotaIds, excludeQuotaIds } = options || {};
  const allow = quotaIds ? quotaIds.map(String) : null;
  const deny = excludeQuotaIds ? excludeQuotaIds.map(String) : null;

  return (rounds || [])
    .filter((round) => {
      const quota = String(round.QUOTA_ID);
      if (allow && allow.length > 0 && !allow.includes(quota)) {
        return false;
      }
      if (deny && deny.includes(quota)) {
        return false;
      }
      return true;
    })
    .sort((a, b) => Number(a.ROB_ID) - Number(b.ROB_ID));
}

/** รอบเปิดให้กดหรือไม่ — respectStatus = false คือให้กดได้ทุกรอบ */
export function isRoundOpen(round, respectStatus) {
  return respectStatus === false ? true : round.ROB_STATUS === "T";
}

/**
 * เติมชื่อรอบและวันเปิด-ปิดจาก API ให้ปุ่มที่ประกาศไว้ใน admissionRound.js
 * จับคู่ด้วย ROB_ID — ปุ่มที่ไม่มีรอบตรงกันใน API จะได้แค่ label จาก config
 *
 * แยกกันชัดเจน: เปิด-ปิดปุ่ม = คุมที่ config, วันที่ = ของจริงจากหลังบ้าน
 */
export function attachRoundMeta(groups, apiRounds) {
  const byId = new Map(
    (apiRounds || []).map((round) => [String(round.ROB_ID), round])
  );

  return groups.map((group) => ({
    ...group,
    items: group.items.map((item) => {
      const api = item.id ? byId.get(String(item.id)) : undefined;
      if (!api) {
        return item;
      }
      return {
        ...item,
        robName: api.ROB_NAME,
        startdate: api.startdate,
        stopdate: api.stopdate,
      };
    }),
  }));
}
